import Login from './Login'
import Registration from './Registration'
const authPages = {
    Login,
    Registration,
}
export default authPages